"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_aio_assets_baseFields = void 0;
exports.SHu_aio_assets_baseFields = [
    "assets.hs_object_id",
    "assets.address",
    "assets.photos",
    "assets.coordinates",
    "properties.bedrooms",
    "properties.bathrooms",
    "properties.sqft",
    "properties.contract_price",
    "properties.matterport_scan_link",
    "properties.matterport_scan_link__at_acquisition_",
    "properties.matterport_scan_link__post_renovation_",
];
